export default "__VITE_ASSET__34a72c24__"